interface I_RadiusControl {
    value: number
    onChange: (km: number) => void
}

const STEPS = [5, 10, 25, 50, 100, 200];

const RadiusControl = ({ value, onChange }: I_RadiusControl) => {
    const change = (km: number) => {
        if (!Number.isFinite(km)) return;

        onChange(Math.min(1000, Math.max(1, Math.round(km))));
    };

    return (
        <div className="radius">
            <label htmlFor="radius">Umkreis</label>

            <div className="radius-input">
                <input
                    id="radius"
                    type="number"
                    min={1}
                    max={1000}
                    value={value}
                    onChange={(event) => change(Number(event.target.value))}
                />
                <span>km</span>
            </div>

            <input
                className="radius-slider"
                type="range"
                min={1}
                max={200}
                value={Math.min(value, 200)}
                onChange={(event) => change(Number(event.target.value))}
            />

            <div className="radius-steps">
                {STEPS.map((km) => (
                    <button key={km} className={km === value ? "active" : ""} onClick={() => change(km)}>{km}</button>
                ))}
            </div>
        </div>
    )
}
export default RadiusControl;